<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between w-full" :class="classes">
        <span class="md:flex hidden justify-around w-full">
            <div class="w-1/2 mt-4">{{ $t('message.mainPage.footer', {phone: '+7 (123) 123-12-34'}) }}</div>
            <div class="w-1/2 text-right">
              <span>Hand-crafted & Made with</span>
              <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
            </div>
        </span>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
